<template>
  <label class="switch">
    <input
      type="checkbox"
      :checked="isChecked"
      v-bind="attrs"
      :class="{ 'read-only': isDisabled }"
      :disabled="isDisabled"
      @click="onToggleSlider"
    />
    <span class="slider round"></span>
  </label>
</template>

<script>
export default {
  name: 'ToggleSwitch',
  props: {
    isChecked: {
      type: Boolean,
      default: false
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    attrs() {
      return this.$attrs;
    }
  },
  methods: {
    onToggleSlider() {
      if (this.isDisabled) return;
      this.$emit('slide', { checked: this.isChecked ? false : true });
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/app/styles/colors.scss';
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: $light-grey-1;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: '';
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: $white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: $toggle-switch-blue;
}

input:checked.read-only + .slider {
  pointer-events: none;
  background-color: $light-grey-1;
}

input:focus + .slider {
  box-shadow: 0 0 1px $toggle-switch-blue;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>
